module.exports = __webpack_public_path__ + "media/images/firsttime_header04_sp-170b09ccebd7b0942a8b4e4949735cde.png";